import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Modal from '../common/Modal';
import Steps from '../common/Steps';
import { JourneyList } from './JourneyList';
import { QuestionList } from '../common/QuestionList';
import { AddQuestion } from '../common/AddQuestion';
import { getCollection, getCollectionList, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { GET_INITIAL_OPTIONS } from '../../constants/exam';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  inputField: {
    width: '97%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
    },
  },
});

export function AddJourneysPopup({ isOpen, setIsOpen }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const collectionInfo = useSelector((state) => state.getCollection.collection);
  const totalJourneyList = useSelector((state) => state.GetJourneyList.journeylist);

  const [step, setStep] = useState(1);
  const [isAddQuestion, setIsAddQuestion] = useState(false);

  const [questions, setquestions] = useState([]);
  const [Exquestions, setExquestions] = useState([]);
  const [totalQuestion, setTotalQeustion] = useState(null);
  const [guides, setGuides] = useState([]);
  const [selectedGuideId, setSelectedGuideId] = useState('');
  const [selectedJId, setSelectedJId] = useState('');
  const [queType, setQueType] = useState('single_select');
  const [queTitle, setQueTitle] = useState('');
  const [options, setOptions] = useState(GET_INITIAL_OPTIONS);
  const [isQEdit, setIsQEdit] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedJid, setSelectedJid] = useState([]);
  const [asssignedJ, setAssignedJ] = useState([]);
  const [assignedJid, setAssignedJid] = useState([]);
  const [configured, setConfigure] = useState('');
  const [examInfo, setExamInfo] = useState({
    numberQuestions: '',
    duration: '',
    passingScore: '',
    instruction: '',
    lockPeriod: '',
    startDate: null,
    endDate: null,
  });
  const [timeUnitEx, setTimeUnitEx] = useState('days');

  const [lockTime, setLockTime] = useState(null);
  const [timeUnit, setTimeUnit] = useState('days');
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    if (collectionInfo?.preAssessmentId && collectionInfo?.postAssessmentId) {
      setConfigure('both');
    } else if (collectionInfo?.preAssessmentId) {
      setConfigure('preAssess');
    } else if (collectionInfo?.postAssessmentId) {
      setConfigure('exam');
    }
  }, [collectionInfo]);

  const getDetails = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', collectionInfo.id).replace('TYPE', 'pre_assessment'),
      );
      setTotalQeustion(res.numberQuestions);
      setquestions(res.questions || []);
      setDates({
        startDate: res.startDate || null,
        endDate: res.endDate || null,
      });
      if (res.lockTime) {
        const parts = res.lockTime.split(' ');
        setLockTime(parts[0]);
        let unit = parts[1];
        // eslint-disable-next-line eqeqeq
        if (parts[0] == '1') {
          unit = `${parts[1]}s`;
        }
        setTimeUnit(unit);
      }
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (collectionInfo.id && (configured === 'preAssess' || configured === 'both')) {
      getDetails();
    }
  }, [collectionInfo, configured]);

  const getExamDetails = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', collectionInfo.id).replace('TYPE', 'post_assessment'),
      );
      const info = {
        numberQuestions: res.numberQuestions,
        duration: res.duration,
        passingScore: res.passingScore,
        instruction: res.instructions,
        startDate: res.startDate || null,
        endDate: res.endDate || null,
      };
      if (res.lockTime) {
        const parts = res.lockTime.split(' ');
        // eslint-disable-next-line prefer-destructuring
        info.lockPeriod = parts[0];
        let unit = parts[1];
        // eslint-disable-next-line eqeqeq
        if (parts[0] == '1') {
          unit = `${parts[1]}s`;
        }
        setTimeUnitEx(unit);
      }

      setExamInfo(info);
      setExquestions(res.questions || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (collectionInfo.id && (configured === 'exam' || configured === 'both')) {
      getExamDetails();
    }
  }, [collectionInfo, configured]);

  useEffect(() => {
    if (selectedJId) {
      const selectedJ = totalJourneyList.filter((j) => j.id === selectedJId)[0];
      const guideList = selectedJ ? selectedJ.guides || [] : [];
      setGuides(guideList);
    }
  }, [selectedJId]);

  const fetchCollection = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.COLLECTION_DETAIL.replace('ID', collectionInfo.id))
      .then((response) => {
        dispatch(getCollection('add', response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const handleUpdateJourney = async (payload) => {
    dispatch(showProgress(true));

    try {
      await service.post(apiEndpoints.COLLECTION_UPDATE_JOURNEY.replace('JOURNEY_ID', collectionInfo.id), payload);
      fetchCollection();

      const objArr = [];
      payload?.journeyIds?.forEach((element) => {
        const obj = totalJourneyList?.filter((item) => item.id === element);
        objArr.push(obj[0]);
      });
      const tempObj = { id: collectionInfo.id, journeys: objArr };
      dispatch(getCollectionList('collectionJourneyCount', tempObj));

      notifySuccess('Journey updated successfully');
      setStep((pre) => pre + 1);
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const getCategorizedQuestionsPre = () => {
    const allQeustions = [...questions];
    const temp = [];
    if (allQeustions && allQeustions.length > 0) {
      allQeustions.forEach((question, indx) => {
        const journeyIndx = temp.findIndex((item) => item.category === question.journeyId);

        if (journeyIndx !== -1) {
          const que = { ...question };
          que.index = indx;
          temp[journeyIndx].questions.push(que);
        } else {
          const que = { ...question };
          que.index = indx;
          temp.push({
            category: question.journeyId,
            questions: [que],
          });
        }
      });
    }
    return temp;
  };

  const getCategorizedQuestionsEx = () => {
    const allQeustions = [...Exquestions];
    const temp = [];
    if (allQeustions && allQeustions.length > 0) {
      allQeustions.forEach((question, indx) => {
        const journeyIndx = temp.findIndex((item) => item.category === question.journeyId);

        if (journeyIndx !== -1) {
          const que = { ...question };
          que.index = indx;
          temp[journeyIndx].questions.push(que);
        } else {
          const que = { ...question };
          que.index = indx;
          temp.push({
            category: question.journeyId,
            questions: [que],
          });
        }
      });
    }
    return temp;
  };

  const onNext = () => {
    if (step === 1) {
      if (assignedJid?.length === selectedJid?.length) {
        ErrorToast('Please add a journey to proceed');
      } else {
        setStep((pre) => pre + 1);
      }
    }

    if (step === 2 && configured === 'both') {
      const categorizedQues = getCategorizedQuestionsPre();
      if (categorizedQues?.length < asssignedJ?.length) {
        ErrorToast('Please add at least 1 question from each journey');
      } else {
        setStep((pre) => pre + 1);
      }
    }

    if (step === 2 && configured === 'preAssess') {
      const categorizedQues = getCategorizedQuestionsPre();
      if (categorizedQues?.length < asssignedJ?.length) {
        ErrorToast('Please add at least 1 question from each journey');
      } else {
        const payload = {
          journeyIds: selectedJid,
          preAssessmentQuestions: {
            examId: collectionInfo.preAssessmentId,
            collectionId: collectionInfo.id,
            numberQuestions: totalQuestion,
            examType: 'pre_assessment',
            startDate: moment(dates.startDate).format('YYYY-MM-DD'),
            endDate: moment(dates.endDate).format('YYYY-MM-DD'),
            questions,
          },
        };
        if (lockTime) {
          let temp = timeUnit;
          // eslint-disable-next-line eqeqeq
          if (lockTime == '1' && timeUnit.endsWith('s')) {
            temp = timeUnit.slice(0, -1);
          }
          payload.preAssessmentQuestions.lockTime = `${lockTime} ${temp}`;
        }
        handleUpdateJourney(payload);
      }
    }
    if (step === 2 && configured === 'exam') {
      const categorizedQues = getCategorizedQuestionsEx();
      if (categorizedQues?.length < asssignedJ?.length) {
        ErrorToast('Please add at least 1 question from each journey');
      } else {
        const payload = {
          journeyIds: selectedJid,
          postAssessmentQuestions: {
            examId: collectionInfo.postAssessmentId,
            collectionId: collectionInfo.id,
            numberQuestions: examInfo.numberQuestions,
            examType: 'post_assessment',
            passingScore: examInfo.passingScore,
            instructions: examInfo.instruction,
            startDate: moment(examInfo.startDate).format('YYYY-MM-DD'),
            endDate: moment(examInfo.endDate).format('YYYY-MM-DD'),
            duration: examInfo.duration,
            questions: Exquestions,
          },
        };
        if (examInfo.lockPeriod) {
          let temp = timeUnitEx;
          // eslint-disable-next-line eqeqeq
          if (examInfo.lockPeriod == '1' && timeUnitEx.endsWith('s')) {
            temp = timeUnitEx.slice(0, -1);
          }
          payload.postAssessmentQuestions.lockTime = `${examInfo.lockPeriod} ${temp}`;
        }
        handleUpdateJourney(payload);
      }
    }
    if (step === 3 && configured === 'both') {
      const categorizedQues = getCategorizedQuestionsEx();
      if (categorizedQues?.length < asssignedJ?.length) {
        ErrorToast('Please add at least 1 question from each journey');
      } else {
        const payload = {
          journeyIds: selectedJid,
          preAssessmentQuestions: {
            examId: collectionInfo.preAssessmentId,
            collectionId: collectionInfo.id,
            numberQuestions: totalQuestion,
            examType: 'pre_assessment',
            startDate: moment(dates.startDate).format('YYYY-MM-DD'),
            endDate: moment(dates.endDate).format('YYYY-MM-DD'),
            questions,
          },
          postAssessmentQuestions: {
            examId: collectionInfo.postAssessmentId,
            collectionId: collectionInfo.id,
            numberQuestions: examInfo.numberQuestions,
            examType: 'post_assessment',
            passingScore: examInfo.passingScore,
            instructions: examInfo.instruction,
            startDate: moment(examInfo.startDate).format('YYYY-MM-DD'),
            endDate: moment(examInfo.endDate).format('YYYY-MM-DD'),
            duration: examInfo.duration,
            questions: Exquestions,
          },
        };
        if (lockTime) {
          let temp = timeUnit;
          // eslint-disable-next-line eqeqeq
          if (lockTime == '1' && timeUnit.endsWith('s')) {
            temp = timeUnit.slice(0, -1);
          }
          payload.preAssessmentQuestions.lockTime = `${lockTime} ${temp}`;
        }
        if (examInfo.lockPeriod) {
          let temp = timeUnitEx;
          // eslint-disable-next-line eqeqeq
          if (examInfo.lockPeriod == '1' && timeUnitEx.endsWith('s')) {
            temp = timeUnitEx.slice(0, -1);
          }
          payload.postAssessmentQuestions.lockTime = `${examInfo.lockPeriod} ${temp}`;
        }
        handleUpdateJourney(payload);
      }
    }
  };
  const onBack = () => {
    if (isAddQuestion) {
      setIsAddQuestion(false);
      clearState();
    } else {
      setStep((pre) => pre - 1);
    }
  };

  const onAdd = () => {
    if (!checkValidation()) return;
    const isPre = step === 2 && (configured === 'preAssess' || configured === 'both');
    const temp = isPre ? [...questions] : [...Exquestions];
    const que = {
      title: queTitle,
      journeyId: selectedJId,
      type: queType,
      options,
    };
    if (selectedGuideId) {
      que.guideId = selectedGuideId;
    }
    if (isQEdit) {
      const editedQuestion = temp[selectedIndex];
      if (editedQuestion.id && editedQuestion.type === queType) {
        que.id = editedQuestion.id;
      }
      temp[selectedIndex] = que;
      if (isPre) {
        setquestions(temp);
      } else {
        setExquestions(temp);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (isPre) {
        setquestions([...temp, que]);
      } else {
        setExquestions([...temp, que]);
      }
    }

    clearState();
    setIsAddQuestion(false);
  };

  const checkValidation = () => {
    const errors = [];
    let isValid = true;

    if (!selectedJId) {
      isValid = false;
      errors.push('Please select a journey');
    }

    if (!queTitle || queTitle.trim() === '') {
      isValid = false;
      errors.push('Please enter a question');
    }

    const emptyOptions = options?.filter((op) => !op.title || op.title.trim() === '') || [];
    if (emptyOptions?.length > 0) {
      isValid = false;
      errors.push('Please enter all the options');
    }

    const answerOptions = options?.filter((op) => op.isAnswer) || [];
    if (answerOptions?.length === 0 && queType === 'single_select') {
      isValid = false;
      errors.push('Please select correct option for the question');
    }
    if (answerOptions?.length < 2 && queType === 'multi_select') {
      isValid = false;
      errors.push('Please select atleast two correct options for the question or change the question type');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };
  const clearState = () => {
    setSelectedGuideId('');
    setSelectedJId('');
    setQueTitle('');
    setQueType('single_select');
    setOptions(GET_INITIAL_OPTIONS);
    setSelectedIndex(null);
    setIsQEdit(false);
  };

  const getButtonText = () => {
    let text = 'Next';
    if (step === 2 && (configured === 'preAssess' || configured === 'exam')) {
      text = 'Save';
    }
    if (step === 3 && configured === 'both') {
      text = 'Save';
    }
    return text;
  };

  return (
    <Modal isOpen={isOpen} height="91vh" width="1000px">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '700', fontSize: '18px' }}>
              Add New Journeys
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        {configured === 'preAssess' && <Steps step={step} stepInfo={['Add Journey', 'Add Pre-Assessment Questions']} />}
        {configured === 'exam' && <Steps step={step} stepInfo={['Add Journey', 'Add Exam Questions']} />}
        {configured === 'both' && (
          <Steps step={step} stepInfo={['Add Journey', 'Add Pre-Assessment Questions', 'Add Exam Questions']} />
        )}

        {step === 1 && (
          <JourneyList
            selectedJid={selectedJid}
            setSelectedJid={setSelectedJid}
            asssignedJ={asssignedJ}
            setAssignedJ={setAssignedJ}
            assignedJid={assignedJid}
            setAssignedJid={setAssignedJid}
          />
        )}

        {step === 2 && isAddQuestion && (configured === 'preAssess' || configured === 'both') && (
          <AddQuestion
            journeys={asssignedJ}
            guides={guides}
            setSelectedGuideId={setSelectedGuideId}
            setSelectedJId={setSelectedJId}
            selectedJId={selectedJId}
            selectedGuideId={selectedGuideId}
            setIsAddQuestion={setIsAddQuestion}
            queType={queType}
            setQueType={setQueType}
            queTitle={queTitle}
            setQueTitle={setQueTitle}
            options={options}
            setOptions={setOptions}
            isEdit={isQEdit}
            questions={questions}
            selectedIndex={selectedIndex}
            calledFrom="collection"
          />
        )}
        {step === 2 && !isAddQuestion && (configured === 'preAssess' || configured === 'both') && (
          <>
            <Grid style={{ background: '#F2F4F7', padding: '10px 20px' }}>
              <Grid style={{ width: '97%' }}>
                <Typography className={classes.required_field}>No. of Questions in the Pre Assessment</Typography>
              </Grid>
              <input
                type="number"
                placeholder="ex. 25"
                className={classes.inputField}
                value={totalQuestion}
                onChange={(e) => {
                  const inp = e.target.value;
                  if (inp >= 0) {
                    setTotalQeustion(inp);
                  }
                }}
              />
            </Grid>

            <QuestionList
              setIsAddQuestion={setIsAddQuestion}
              questions={questions}
              setQeustions={setquestions}
              setIsEdit={setIsQEdit}
              setSelectedIndex={setSelectedIndex}
              calledFrom="collectionAssesment"
              journeys={asssignedJ}
            />
          </>
        )}

        {step === 2 && isAddQuestion && configured === 'exam' && (
          <AddQuestion
            journeys={asssignedJ}
            guides={guides}
            setSelectedGuideId={setSelectedGuideId}
            setSelectedJId={setSelectedJId}
            selectedJId={selectedJId}
            selectedGuideId={selectedGuideId}
            setIsAddQuestion={setIsAddQuestion}
            queType={queType}
            setQueType={setQueType}
            queTitle={queTitle}
            setQueTitle={setQueTitle}
            options={options}
            setOptions={setOptions}
            isEdit={isQEdit}
            questions={Exquestions}
            selectedIndex={selectedIndex}
            calledFrom="collection"
          />
        )}
        {step === 2 && !isAddQuestion && configured === 'exam' && (
          <QuestionList
            setIsAddQuestion={setIsAddQuestion}
            questions={Exquestions}
            setQeustions={setExquestions}
            setIsEdit={setIsQEdit}
            setSelectedIndex={setSelectedIndex}
            calledFrom="collectionAssesment"
            journeys={asssignedJ}
          />
        )}

        {step === 3 && isAddQuestion && configured === 'both' && (
          <AddQuestion
            journeys={asssignedJ}
            guides={guides}
            setSelectedGuideId={setSelectedGuideId}
            setSelectedJId={setSelectedJId}
            selectedJId={selectedJId}
            selectedGuideId={selectedGuideId}
            setIsAddQuestion={setIsAddQuestion}
            queType={queType}
            setQueType={setQueType}
            queTitle={queTitle}
            setQueTitle={setQueTitle}
            options={options}
            setOptions={setOptions}
            isEdit={isQEdit}
            questions={Exquestions}
            selectedIndex={selectedIndex}
            calledFrom="collection"
          />
        )}
        {step === 3 && !isAddQuestion && configured === 'both' && (
          <QuestionList
            setIsAddQuestion={setIsAddQuestion}
            questions={Exquestions}
            setQeustions={setExquestions}
            setIsEdit={setIsQEdit}
            setSelectedIndex={setSelectedIndex}
            calledFrom="collectionExam"
            journeys={asssignedJ}
          />
        )}

        <Grid style={{ display: 'flex' }}>
          {step > 1 && (
            <Button onClick={onBack} variant="outlined">
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              {(step === 2 || step === 3) && isAddQuestion ? (
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onAdd}>
                  Add
                </Button>
              ) : (
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onNext}>
                  {getButtonText()}
                </Button>
              )}
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
